import { Radio } from "components-new";
import ModalPortal from "components-new/ModalPortal";
import Button, { BUTTON_VARIANTS } from "components/shared/Button/Button";
import { FC, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { setCommission } from "toolkit/steps/stepOne/stepOne.slice";
import { Commission } from "toolkit/steps/stepOne/stepOne.types";
import styles from "./JoinCommission.module.sass";

interface JoinCommissionProps {
	existingCommissions: Commission[];
	handleClose: () => void;
}

const JoinCommission: FC<JoinCommissionProps> = ({ existingCommissions, handleClose }) => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const { organizationId } = useParams();

	const currentCommission = useAppSelector((state) => state.stepOne.currentCommission);

	useEffect(() => {
		dispatch(setCommission({ commission: null, commissionId: 0 }));
		//eslint-disable-next-line
	}, []);

	const onEnter = () => {
		navigate(`/commission/${organizationId}/${currentCommission?.id}`);
	};

	return (
		<ModalPortal handleClose={handleClose} outSide={false} title="Подключиться к существующей комиссии">
			<div className={styles.radiosTitle}>Выбрать комиссию</div>
			<div className={styles.radios}>
				{existingCommissions.map((commission) => (
					<Radio
						key={commission.id}
						className={styles.radio}
						label={
							<>
								<div className={styles.label}>{commission.organisation.fullName}</div>
								<div className={styles.date}>Утверждена {commission.startDate}</div>
							</>
						}
						name="commission"
						checked={commission.id === currentCommission?.id}
						value={String(commission.id)}
						handleSelected={() =>
							dispatch(
								setCommission({
									commission,
									commissionId: commission.id,
								}),
							)
						}
					/>
				))}
			</div>
			<div className={styles.buttons}>
				<Button full variant={BUTTON_VARIANTS.OUTLINED} onClick={handleClose} className={styles.button}>
					Отменить
				</Button>
				<Button full className={styles.button} onClick={onEnter}>
					Готово
				</Button>
			</div>
		</ModalPortal>
	);
};

export default JoinCommission;
